// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationElement_container__3u1wB","image":"NotificationElement_image__1BF9w","redirect":"NotificationElement_redirect__2lcTy"};